// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Form__Label = require("./Form__Label.bs.js");
var InputStyles = require("./InputStyles.bs.js");
var TailwindMerge = require("tailwind-merge");
var Form__HelpLabel = require("./Form__HelpLabel.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var TailwindVariants = require("tailwind-variants");
var ReactAriaComponents = require("react-aria-components");

var textareaStyles = TailwindVariants.tv({
      base: "resize-none",
      variants: {
        isDisabled: {
          true: "bg-zinc-50 text-zinc-500"
        }
      }
    });

var Styles = {
  textareaStyles: textareaStyles
};

function Form__TextAreaField(props) {
  var __rows = props.rows;
  var status = props.status;
  var helpText = props.helpText;
  var labelText = props.labelText;
  var rows = __rows !== undefined ? __rows : 5;
  return JsxRuntime.jsxs(ReactAriaComponents.TextField, {
              children: [
                labelText !== undefined ? JsxRuntime.jsx(Form__Label.make, {
                        labelText: labelText,
                        optionalText: props.optionalText
                      }) : null,
                helpText !== undefined ? JsxRuntime.jsx(Form__HelpLabel.make, {
                        children: helpText
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ReactAriaComponents.TextArea, {
                            className: (function (r) {
                                return TailwindMerge.twMerge([
                                            InputStyles.baseInputStyles,
                                            InputStyles.inputStyles({
                                                  isFocused: r.isFocused,
                                                  isInvalid: r.isInvalid,
                                                  isDisabled: r.isDisabled,
                                                  status: status
                                                }),
                                            textareaStyles(r)
                                          ]);
                              }),
                            ref: props.inputRef,
                            onChange: props.onChange,
                            onKeyDown: props.onKeyDown,
                            onBlur: props.onBlur,
                            onFocus: props.onFocus,
                            disabled: props.disabled,
                            rows: rows
                          }),
                      className: "flex flex-col"
                    })
              ],
              className: (function (_r) {
                  return "flex flex-col";
                }),
              id: props.id,
              value: props.value,
              placeholder: props.placeholderText
            });
}

var make = Form__TextAreaField;

exports.Styles = Styles;
exports.make = make;
/* textareaStyles Not a pure module */
